import React, { useState } from "react";
import {
  menuUrl,
  tableTitle,
  keyColumn,
  tableColumn,
  breadCrumbs,
  filters as rawFilters,
} from "@screens/products/products-list/model/product-list.constants";
import { getFilterData } from "@utils/common";
import {
  constructFilterDataAndGetQueryString,
  getFilterQueryString,
  getParamsData,
} from "@utils/filters.util";
import { APP } from "@constants/app.constants";
import { useHistory } from "react-router-dom";
import { checkMenuAccess } from "@utils/menu-auth";
import MESSAGES from "@constants/messages.constants";
import { useDispatch, useSelector } from "react-redux";
import { setAlertMessage } from "@reducers/alert.reducer";
import {
  deleteDataApi,
  getDataApi,
} from "./product-list.component.service";
import { useEffect } from "react";
import ProductsListTemplateComponent from "./product-list.template.component";

const {
  ALERT_TYPES: { SUCCESS, ERROR },
  PRODUCTS_ALERTS: { DELETE_ALERT }
} = MESSAGES;
const { ROWS_PER_PAGE } = APP;

const ProductsListComponent = () => {
  const { filterList } = useSelector((state) => state.filter);
  const [tableData, setTableData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const history = useHistory();
  const dispatch = useDispatch();
  const filters = getFilterData(filterList, menuUrl, "filter");
  const menuAccess = checkMenuAccess(menuUrl, "read");
  const tableParams = getParamsData(filterList, menuUrl);
  const [filterState, setFilterState] = useState(filters);
  const { appRowsPerPage } = useSelector((state) => state.app);

  const getPromoCodeData = async (params = null) => {
    console.log({ params });
    const queryStr = getFilterQueryString(menuUrl, params);
    const customerData = await getDataApi({
      ...params,
      filters: queryStr,
    });
    if (customerData.status) {
      console.log(customerData);
      setTableData(customerData.data);
      setTotalCount(customerData.totalCount);
    }
  };

  const handleCreateClick = () => {
    history.push(`/${menuUrl}/create`);
  };

  const deleteRecords = async (selected) => {
    const deleteAccess = checkMenuAccess(menuUrl, "delete");
    if (deleteAccess) {
      const response = await deleteDataApi(selected);
      if (response.status) {
        dispatch(
          setAlertMessage({ type: SUCCESS, message: DELETE_ALERT, viewed: 0 })
        );
        getPromoCodeData({
          orderBy: "created_at",
          sortBy: "desc",
          skip: 0,
          limit: appRowsPerPage || ROWS_PER_PAGE,
        });
      } else {
        dispatch(
          setAlertMessage({ type: ERROR, message: response.message, viewed: 0 })
        );
      }
    } else
      dispatch(
        setAlertMessage({
          type: ERROR,
          message: "Permission denied to delete",
          viewed: 0,
        })
      );
  };

  const onLoad = async () => {
    const copyFilters = rawFilters();
    console.log({ copyFilters });
    setFilterState(copyFilters);
  };

  useEffect(() => {
    onLoad();
  }, []);

  const submitFilter = (filters) => {
    const queryStr = constructFilterDataAndGetQueryString(filters, menuUrl);
    console.log({ queryStr });
    getPromoCodeData({
      orderBy: "created_at",
      sortBy: "desc",
      skip: 0,
      limit: appRowsPerPage || ROWS_PER_PAGE,
      filters: queryStr,
    });
  };
  console.log({ tableData });

  return menuAccess ? (
    <ProductsListTemplateComponent
      templateModal={{
        tableTitle,
        keyColumn,
        breadCrumbs,
        tableColumn,
        tableData,
        totalCount,
        filters: filterState,
        tableParams,
      }}
      templateEvents={{
        getPromoCodeData,
        handleCreateClick,
        deleteRecords,
        submitFilter,
      }}
    />
  ) : (
    <> </>
  );
};

export default ProductsListComponent;